import { ColumnDataProps } from "@saviynt/design-system";
import { type IntlShape } from "react-intl";

export const defaultColumnConfig = {
  isDisabled: false,
  isChecked: true,
  isSortable: true,
};

export const createColumn = (
  key: string,
  label: string,
  width: string,
  overrides = {},
) => ({
  key,
  label,
  value: key,
  width,
  ...defaultColumnConfig,
  ...overrides,
});

export const getUsersTableColumns = (intl: IntlShape): ColumnDataProps[] => [
  createColumn(
    "name",
    intl.formatMessage({
      id: "zv+Mrw",
      defaultMessage: "Name",
      description: "Table column header for name description",
    }),
    "15rem",
    {
      isPinned: true,
      hasCheckbox: false,
    },
  ),
  createColumn(
    "savRole",
    intl.formatMessage({
      id: "SmW0BV",
      defaultMessage: "Sav Role",
      description: "Table column header for sav role description",
    }),
    "12rem",
  ),
  createColumn(
    "lastAccessedAt",
    intl.formatMessage({
      id: "Pp/ts1",
      defaultMessage: "Last Login",
      description: "Table column header for last login",
    }),
    "12rem",
  ),

  createColumn(
    "createdBy",
    intl.formatMessage({
      id: "oya7RV",
      defaultMessage: "Created By",
      description: "Table column header for Created By",
    }),
    "12rem",
  ),

  createColumn(
    "createdAt",
    intl.formatMessage({
      id: "qDiIrW",
      defaultMessage: "Created On",
      description: "Table column header for Created By",
    }),
    "12rem",
  ),
  createColumn(
    "status",
    intl.formatMessage({
      id: "k2W6dA",
      defaultMessage: "Status",
      description: "Table column header for role status",
    }),
    "12rem",
  ),
  createColumn("actionColumn", "actionColumn", "min-content", {
    isPinned: true,
    isColumnConfigEnabled: true,
  }),
];

const ascSortConfig = {
  value: "asc",
  isDisabled: false,
  isChecked: false,
  icon: "ArrowUp",
  shouldShowCheckIcon: false,
};

const descSortConfig = {
  value: "desc",
  isDisabled: false,
  isChecked: false,
  icon: "ArrowDown",
  shouldShowCheckIcon: false,
};

export const getAlphabeticalSort = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "RDNWPD",
      defaultMessage: "Ascending",
      description: "Sort option label for ascending order",
    }),
    ...ascSortConfig,
  },
  {
    label: intl.formatMessage({
      id: "KlQp5v",
      defaultMessage: "Descending",
      description: "Sort option label for descending order",
    }),
    ...descSortConfig,
  },
];

export const getSortConfigs = (intl: IntlShape) => {
  const alphabeticalSort = getAlphabeticalSort(intl);

  return [
    { key: "name", sortOptions: alphabeticalSort },
    { key: "savRole", sortOptions: alphabeticalSort },
    { key: "lastAccessedAt", sortOptions: alphabeticalSort },
    { key: "createdBy", sortOptions: alphabeticalSort },
    { key: "createdAt", sortOptions: alphabeticalSort },
    { key: "status", sortOptions: alphabeticalSort },
  ];
};

export const getKebabMenuList = (intl: IntlShape, userStatus?: string) => [
  {
    label: intl.formatMessage({
      defaultMessage: "Reset Password",
      id: "9ciQ50",
      description: "Kebab menu option",
    }),
    value: "resetPassword",
  },
  {
    label:
      userStatus?.toUpperCase() === "DISABLED"
        ? intl.formatMessage({
            defaultMessage: "Enable User",
            id: "E3cR+N",
            description: "Kebab menu option to enable a disabled user",
          })
        : intl.formatMessage({
            defaultMessage: "Disable User",
            id: "t/BrQ2",
            description: "Kebab menu option",
          }),
    value:
      userStatus?.toUpperCase() === "DISABLED" ? "enableUser" : "disableUser",
  },
  {
    label: intl.formatMessage({
      defaultMessage: "Reset TOTP",
      id: "HXc6am",
      description: "Kebab menu option",
    }),
    value: "resetTOTP",
  },
];
